<template>
  <div class="container-fluid preview">
    <header>
      <base target="_blank"/>
    </header>
    <div class="row">
      <div class="col">
        <br>
        <h4 style="font-family:arial"> {{this.versionName}} {{this.listName}}</h4>
        <br>
        <h3 style="font-family:arial" class="text-left">Categories: </h3>
        <div v-for="category in categoryList" v-bind:key="category">
          <div class="text-left">
            <h5 style="font-family:arial" class="mb-1">{{category}}</h5>
          </div>
        </div>
        <br>
        <!-- <div v-for="result in finalList" v-bind:key="result.guid">
          <div class="card">
            <div class="card-body text-left">
              <h5 style="text-decoration:underline" class="mb-1">Category: {{result.category}}</h5>
              <h5 class="mb-1">{{result.title}}</h5>
              <small>{{result.pubDate}}</small>
              <p class="mb-1" v-html="result.comments"></p>
              <a :href="result.link"> Read More </a>
            </div>
          </div>
        </div> -->
        <div v-for="category in categoriesAndArticles" v-bind:key="category">
          <!-- <div v-for="cat in categoryList" v-bind:key="cat"> -->
            <br>
            <div class="text-left">
          <h3 style="font-family:arial ; text-decoration:underline" class="mb-1">Category: {{category[0].category}}</h3>
            </div>
          <br>
          <div v-for="result in category" v-bind:key="result.guid">
            <div class="card">
            <div class="card-body text-left">
              <h5 style="font-family:arial" class="mb-1">{{result.title}}</h5>
              <small v-if="result.pubDate">{{result.pubDate.slice(0,17)}}</small>
              <small v-else>{{result.pubDate}}</small>
              <p style="font-family:arial; fontsize:10px" class="mb-1" v-html="result.comments"></p>
              <a :href="result.link"> Read More </a>
            </div>
          <!-- </div> -->
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleService from '@/ArticleService'

export default {
  name: 'DynamicList',
  data: function () {
    return {
      listName: '',
      resultList: [],
      categoryList: [],
      finalList: [],
      versionName: '',
      categoriesAndArticles: {}
    }
  },
  async created () {
    // console.log(this.$route.params)
    this.listName = this.$route.params.list
    this.versionName = this.$route.params.version
    this.resultList = await ArticleService.getbyListandVersion(this.listName, this.versionName)
    // console.log(this.resultList)
    // this.categoryList = await ArticleService.getCategoriesbyListandVersion(this.listName, this.versionName)
    // this.resultList.sort(function (a, b) {
    //   if (a.category.toUpperCase() > b.category.toUpperCase()) { return -1 }
    //   if (a.category.toUpperCase() < b.category.toUpperCase()) { return 1 }
    //   return 0
    // })
    console.log(this.resultList)
    this.resultList.forEach(element => {
      // console.log(element.category)
      if (!this.categoryList.includes(element.category)) {
        this.categoryList.push(element.category)
      }
    })
    this.categoryList.sort(function (a, b) {
      if (a !== null && b !== null) {
        if (a.toUpperCase() > b.toUpperCase()) { return 1 }
        if (a.toUpperCase() < b.toUpperCase()) { return -1 }
        return 0
      }
    })
    console.log(this.categoryList)
    this.categoryList.forEach(category => {
      this.resultList.forEach(article => {
        if (article.category === category) {
          this.finalList.push(article)
        }
      })
    })
    this.categoryList.forEach(category => {
      console.log(category)
      this.categoriesAndArticles[category] = []
      this.resultList.forEach(article => {
        if (article.category === category) {
          this.categoriesAndArticles[category].push(article)
        }
      })
    })
    console.log(this.finalList)
    console.log(this.categoriesAndArticles)
  }
}
</script>

<style scoped>

</style>
